// S ::::: 연혁 ::::: S
export const historyLists = [
  {
    title: "2026",
    lists: [
      {
        date: "2026.08",
        text: "남양주지부 오픈",
      },
      {
        date: "2026.07",
        text: "전문자격증 취득자 대상 2026 IPDIA 작품세미나",
      },
      {
        date: "2026.06",
        text: "셔플댄스 지도자 자격증 2급 - 3기 수료",
      },
      {
        date: "2026.03",
        text: "경기광주지부 오픈",
      },
      {
        date: "2026.03",
        text: "셔플댄스 지도자 자격증 1급 - 1기 수료",
      },
    ],
  },
  {
    title: "2025",
    lists: [
      {
        date: "2025.12",
        text: "국제실용댄스지도자협회 콘서트 주최",
      },
      {
        date: "2025.08",
        text: "전문자격증 취득자 대상 역량강화 워크샵",
      },
      {
        date: "2025.05",
        text: "셔플댄스 지도자 자격증 2급 - 2기 수료",
      },
      {
        date: "2025.04",
        text: "대전지부 오픈",
      },
      {
        date: "2025.01",
        text: "셔플댄스 지도자 자격증 2급 - 1기 수료",
      },
    ],
  },
  {
    title: "2024",
    lists: [
      {
        date: "2024.12",
        text: "협회 교육위원회 조직 결성",
      },
      {
        date: "2024.11",
        text: " 본부 트레이닝 센터 넵튠댄스스튜디오 오픈",
      },
      {
        date: "2024.11",
        text: "IPDIA 국제실용댄스지도자협회 창단",
      },
    ],
  },
];
// E ::::: 연혁 ::::: E
